export function isNullOrEmpty(value: any): boolean {
  if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) return true;
  return false;
}
